import { Todo } from '@deliveries-app/models';
import api from '../../api';
import { GetAllTodosResponse } from '../models/todos-response.interface';

/**
 * Get all Todos
 *
 * @param {number} branch_id
 * @param {string} date
 *
 * @returns {Promise<Todo[]>}
 */
export async function getAllTodos(
  branch: number,
  date: string
): Promise<Todo[]> {
  try {
    const res = await api.get<GetAllTodosResponse>(
      `/api/v1/branches/${branch}/tasks`,
      {
        params: {
          date: date,
        },
      }
    );

    return res.data.data;
  } catch (err) {
    console.log('Get current booking request failed', err);
    throw err;
  }
}

/**
 * Create a single Todo
 *
 * @param {number} branch_id
 * @param {string} date
 * @param {string} content
 *
 * @returns {Promise<Todo>}
 */
export async function createTodo(
  branch_id: number,
  date: string,
  content: string
): Promise<Todo> {
  try {
    const res = await api.post<{ data: Todo }>(
      `/api/v1/branches/${branch_id}/tasks/create`,
      {
        branch_id: branch_id,
        date: date,
        content: content,
      }
    );

    return res.data.data;
  } catch (err) {
    console.log('Get current booking request failed', err);
    throw err;
  }
}

/**
 * Update a single Todo
 *
 * @param {number} branch_id
 * @param {number} todo_id
 * @param {string} content
 * @param {boolean} completed
 *
 * @returns {Promise<void>}
 */
export async function updateTodo(
  branch_id: number,
  todo_id: number,
  content: string,
  completed: boolean
): Promise<boolean> {
  try {
    const res = await api.patch(
      `/api/v1/branches/${branch_id}/tasks/${todo_id}`,
      {
        id: todo_id,
        content: content,
        completed_at: completed,
      }
    );

    return res.data.data.completed_at;
  } catch (err) {
    console.log('Get current booking request failed', err);
    throw err;
  }
}

/**
 * Delete a single Todo
 *
 * @param {number} todo_id
 *
 * @returns {Promise<void>}
 */
export async function deleteTodo(
  branch_id: number,
  todo_id: number
): Promise<any> {
  try {
    const res = await api.delete(
      `/api/v1/branches/${branch_id}/tasks/${todo_id}`,
      {
        data: { id: todo_id },
      }
    );

    return res;
  } catch (err) {
    console.log('Get current booking request failed', err);
    throw err;
  }
}

export const todosService = {
  getAllTodos,
  createTodo,
  deleteTodo,
  updateTodo,
};
